/*@ngInject*/
module.exports = function(accessibilityService) {
	return {
		scope: {
			viewMode: '=',
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function() {
			let vm = this;

			accessibilityService.getByPageName('ACCESSIBILITY INFORMATION').then((res) =>{
				vm.accessibilityInfo = res.data;
			});

			accessibilityService.getArticles().then((res) =>{
				vm.articles = res.data.articles;
				vm.links = res.data.links;
				vm.functionality = res.data.functionality;
			});

		},
		template: require('./accessibility.html')
	};
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/accesssibility/accessibility.directive.js
 **/